/* global window */
/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import withTranslate from 'react-redux-multilingual/lib/withTranslate';
import { get, map, orderBy, take } from 'lodash';
import { requestSectorAllocation, requestTopHoldings } from 'Actions/MorningstarActions';
import InfoPopupModern from 'components/InfoPopup/InfoPopupModern';
import SlideToggle from 'components/SlideToggle/SlideToggle';
import './TopHoldings.scss';

const TopHoldings = props => {
	const dispatch = useDispatch();
	const { format } = window;
	const {
		translate,
		xids,
		symbol,
		country
	} = props;

	const [showTop5Sectors, setShowTop5Sectors] = useState(true);
	const [visibleGraphData, setVisibleGraphData] = useState([]);
	const sectorAllocationData = useSelector(state => get(state, 'morningstarData.sectorAllocationData'));
	const fetchingSectorAllocationData = useSelector(state => get(state, 'morningstarData.fetchingSectorAllocationData'));
	const topHoldingsData = useSelector(state => get(state, 'morningstarData.topHoldingsData'));
	const fetchingTopHoldings = useSelector(state => get(state, 'morningstarData.fetchingTopHoldings'));

	useEffect(() => {
		if (!showTop5Sectors) {
			return;
		}
		dispatch(requestSectorAllocation(xids.venue));
	}, [xids, showTop5Sectors]);

	useEffect(() => {
		if (showTop5Sectors) {
			return;
		}
		dispatch(requestTopHoldings(xids.venue));
	}, [xids, showTop5Sectors]);


	useEffect(() => {
		if (showTop5Sectors) {
			let newGraphData = [];
			if (get(sectorAllocationData, 'sectors.0.value')) {
				newGraphData = take(
					orderBy(
						map(sectorAllocationData.sectors, sectorAllocationDatum => {
							const { name } = sectorAllocationDatum;
							let translatedName = name.toLowerCase().replace(/\W/g, '');
							if (translatedName) {
								translatedName = translate(translatedName);
							}
							return {
								label: translatedName || name,
								value: sectorAllocationDatum.value
							};
						}, []),
						['value'], ['desc']
					),
					5
				);
			}
			setVisibleGraphData(newGraphData);
		} else if (!showTop5Sectors) {
			let newGraphData = [];
			if (get(topHoldingsData, '0.value')) {
				newGraphData = take(
					orderBy(
						map(topHoldingsData, topHoldingsDatum => ({
							label: topHoldingsDatum.name,
							value: topHoldingsDatum.value
						}), []),
						['value'], ['desc']
					),
					5
				);
			}
			setVisibleGraphData(newGraphData);
		}
	}, [showTop5Sectors, sectorAllocationData, topHoldingsData]);

	const colorArray = ['#34347A', '#0767A8', '#D65421', '#017F70', '#99314F'];
	const highestHoldingPercentage = get(visibleGraphData, '0.value', 1);
	let barChart = map(visibleGraphData, (visibleGraphDatum, index) => {
		const barChartEntryGraphFillPercentage = (visibleGraphDatum.value / highestHoldingPercentage) * 100;
		return (
			<div className="top-holdings-bar-chart-entry" role="group">
				<span
					className="top-holdings-bar-chart-entry-graph"
					style={{ background: `linear-gradient(to left, ${colorArray[index]} ${barChartEntryGraphFillPercentage}%, rgba(255,0,0,0) 0%)` }} />
				<span className="top-holdings-bar-chart-entry-percentage">{ format.percentNoSign(visibleGraphDatum.value, 2) }</span>
				<span className="top-holdings-bar-chart-entry-label">{ visibleGraphDatum.label }</span>
			</div>
		);
	});

	if (barChart.length <= 0 && !fetchingSectorAllocationData && !fetchingTopHoldings) {
		barChart = (
			<div>
				{translate('noDataAvailable')}
			</div>
		);
	}

	return (
		<div className="top-holdings">
			<div className="top-holdings-title-line">
				<span className="top-holdings-title">{translate('top5Holdings')}</span>
				<span className="top-holdings-title-tooltip">
					<InfoPopupModern>
						{translate('top5HoldingsTooltip')}
					</InfoPopupModern>
				</span>
				<span className="top-holdings-title-link">
					{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
					<a
						role="link"
						tabIndex="0"
						onKeyDown={event => {
							if (event.keyCode === 13) {
								window.mdPageActions.navigateOBR('etf-portfolio', { market: country, symbol });
							}
						}}
						onClick={() => {
							window.mdPageActions.navigateOBR('etf-portfolio', { market: country, symbol });
						}}>
						{translate('more')}
					</a>
				</span>
			</div>
			<div className="top-holdings-toggle-line">
				<span className={showTop5Sectors ? 'top-holdings-toggle-on' : 'top-holdings-toggle-off'}>{translate('sector')}</span>
				<SlideToggle
					screenReaderText={translate(showTop5Sectors ? 'showEntityHoldings' : 'showSectorHoldings')}
					leftItem={{ value: true }}
					rightItem={{ value: false }}
					value={showTop5Sectors}
					callback={() => setShowTop5Sectors(!showTop5Sectors)} />
				<span className={showTop5Sectors ? 'top-holdings-toggle-off' : 'top-holdings-toggle-on'}>{translate('entity')}</span>
			</div>
			<div className="top-holdings-bar-chart">
				{barChart}
			</div>

		</div>
	);
};

export default withTranslate(TopHoldings);
